import React from 'react';
import {
  translate as t,
} from 'admin-on-rest';
import { ListItem } from 'material-ui';

import { getTranslationByLocale } from '../../../utils/TranslationUtils';

const Button = t(({ block, locale }) => (
  <ListItem disabled className="button" primaryText={getTranslationByLocale(block.text, locale)} secondaryText={block.link} />
));

export default Button;
